import { formatMoney } from "@/lib/format";
import { timeAgo } from "@/lib/timeAgo";

/**
 * Recent donations: who gave, how much, their message and when. Donor
 * names arrive already abbreviated (or "Anonymous") from the server.
 */
export default function SupportersList({ donations, limit = 8, className = "" }) {
  const shown = donations.slice(0, limit);
  if (shown.length === 0) return null;

  return (
    <ul className={`divide-y divide-border overflow-hidden rounded-xl border border-border bg-card ${className}`}>
      {shown.map((d) => (
        <li key={d.id} className="flex items-start gap-3 px-4 py-3">
          <div className="min-w-0 flex-1 text-sm">
            <p className="font-medium text-foreground">{d.donor_name}</p>
            {d.donor_message && <p className="mt-0.5 break-words italic text-muted-foreground">“{d.donor_message}”</p>}
            <p className="mt-0.5 text-xs text-muted-foreground">{timeAgo(d.paid_at)}</p>
          </div>
          <span className="shrink-0 font-semibold text-primary font-tabular">{formatMoney(d.amount_cents)}</span>
        </li>
      ))}
    </ul>
  );
}
